module.exports = __webpack_public_path__ + "0bfa7a36ce9851409371ebe8027c7d80.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/sm-320.webp
// module id = 534
// module chunks = 0